var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstantMix(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.21664 14.1V9.20002H0.849976V7.43336H5.34998V9.20002H3.98331V14.1H2.21664ZM2.21664 6.43336V1.90002H3.98331V6.43336H2.21664ZM5.74998 5.75002V3.98336H7.11664V1.90002H8.88331V3.98336H10.25V5.75002H5.74998ZM7.11664 14.1V6.75002H8.88331V14.1H7.11664ZM12.0166 14.1V11.9834H10.65V10.2167H15.15V11.9834H13.7833V14.1H12.0166ZM12.0166 9.21669V1.90002H13.7833V9.21669H12.0166Z",
    fill: "#172128"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstantMix);
export default __webpack_public_path__ + "static/media/instant_mix.6315e77bfc2a08e9b76cde586573b3f9.svg";
export { ForwardRef as ReactComponent };